import React from "react";
import { WhatsAppWidget } from "react-whatsapp-widget";
import "react-whatsapp-widget/dist/index.css";
import "./WhatsAppFloatingWidget.css";

const WhatsAppFloatingWidget = () => {
  return (
    <WhatsAppWidget
      phoneNumber="919884702223"
      companyName="BharatVidyarthi"
      message="Hello!\n\nI need help with college admissions."
      replyTimeText="Typically replies quickly"
      sendButtonText="Send"
      inputPlaceHolder="Type a message"
    />
  );
};

export default WhatsAppFloatingWidget;
